module.exports = __webpack_public_path__ + "static/media/color-spinner.e275bf6b.gif";